import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import cn from 'classnames';

// todo: make this work
// import ClaimButton from './ClaimButton';

export default class WinPage extends Component {
    constructor(props) {
        super(props);

        const { currentAddress, winningAddress } = this.props;
        this.state = {
            isWinner: currentAddress && winningAddress && (winningAddress === currentAddress),
        };
    }

    render() {
        const { gameId } = this.props;
        const classNames = cn('winPage', { 'winner': this.state.isWinner });

        if (this.state.isWinner) {
            return (
                <div className={classNames}>
                    <div className="game-info">
                        <p> Congratulations! You're a Hash Hero!</p>
                        <p> Refresh the page to claim your winnings.</p>
                        <div className="read-more">
                            <Link to="/winners">Bask in the glory...</Link>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div className={classNames}>
                    <div className="game-info">
                        <p> Someone else won the previous game. </p>
                        <p> Refresh the page to enter the next game! </p>
                        <div className="read-more">
                            <Link to={`/boards/${gameId}`}>Return to the arena!</Link>
                        </div>
                    </div>
                </div>
            );
        }
    }

}



// WEBPACK FOOTER //
// ./src/components/WinPage.js